import { buildCvRoute, buildTailoredCvRoute } from "../../lib/cv-target-route";

/** Saved CV docks must keep every editor/checklist action on the opened CV. */
export function getCvBottomBarTarget(
  target?: string | null,
  tailoredId?: string | null,
) {
  return tailoredId?.trim() || target?.trim() || null;
}

export function buildCvBottomBarEditorRoute(
  path: string,
  target?: string | null,
  tailoredId?: string | null,
) {
  const cvId = tailoredId?.trim();
  if (!cvId) return buildCvRoute(path, target);
  const suffix = path
    .replace(/^\/\([^/]+\)\/cv\/?/, "")
    .replace(/^\/cv\/?/, "")
    .replace(/^\/+/, "");
  return buildTailoredCvRoute(cvId, suffix);
}
